module.exports = __webpack_public_path__ + "media/images/icons/chalkboard-teacher-0f70027a0a757e85e3d2a2213734252e.svg";